import Error from './components'

export default {
  key: 'error',
  component: Error,
}
